import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Tooltip
} from '@material-ui/core';
import InputNumber from 'components/base/InputNumber';
import Icon from 'components/base/Icon';
import { LBButton } from '@linearb/buzz';

const LimitToggler = ({
  limit,
  updateLimit,
  showAllSegments,
  toggleShowAllSegments
}) => {
  return (
    <div>
      <FormControl>
        <RadioGroup
          name='limit-toggler-group'
          value={showAllSegments.toString()}
        >
          <div className='flex flex-row items-center gap-2'>
            <FormControlLabel
              value='false'
              control={
                <Radio
                  color='primary'
                  {...(showAllSegments && { onClick: toggleShowAllSegments })}
                />
              }
            />
            Show up to
            <InputNumber
              value={limit}
              onChange={updateLimit}
              max={20}
              min={1}
              disabled={showAllSegments}
            />
            segments
          </div>
          <div className='flex flex-row items-center gap-2'>
            <FormControlLabel
              value='true'
              control={
                <Radio
                  color='primary'
                  {...(!showAllSegments && { onClick: toggleShowAllSegments })}
                />
              }
            />
            Show all segments
            <Tooltip title='limited to 50 segments max'>
              <LBButton variant='ghost' size='icon'>
                <Icon name='InfoOutlined' size='small' />
              </LBButton>
            </Tooltip>
          </div>
        </RadioGroup>
      </FormControl>
    </div>
  );
};

export default LimitToggler;
